import contract_type from "dictionaries/contract_type.json";
import createOptions from "utils/createOptions";

export default createOptions(contract_type);
